import { createFileRoute } from '@tanstack/react-router';

import { CompanyOverviewPage } from '@/features/org/overview-page';

export const Route = createFileRoute('/_app/org/$orgId/overview')({
  component: CompanyOverview,
});

function CompanyOverview() {
  const { orgId } = Route.useParams();
  return <CompanyOverviewPage orgId={orgId} />;
}
